import Vue from 'vue';
import JsonViewer from 'vue-json-viewer';

import 'vue-json-viewer/style.css';

Vue.use(JsonViewer);
